// import Vue from "vue";
import axios from "axios";

import config from "@/config";
import store from "@/store";
import i18n from "@/modules/i18n";
import { intercepterUnauthorized } from "@/modules/finSession";

const ignorePaths = [
  "api/tache/",
  "api/notification",
];

export default (objConfigParam) => {
  const objConfig = objConfigParam || {};

  const instance = axios.create({
    withXSRFToken: true,
    xsrfHeaderName: "X-CSRFToken",
    xsrfCookieName: "csrfnumerique",
    withCredentials: true,
    baseURL: config.api.baseUrl,
    timeout: objConfig.timeout || 600000,
  });

  instance.interceptors.request.use((axiosConfig) => {
    axiosConfig.headers["Accept-Language"] = i18n?.global?.locale?.value || "fr";
    return axiosConfig;
  });
  instance.interceptors.response.use(
    null,
    (err) => {
      // Une requête annulée via AbortController est un flux normal.
      if (axios.isCancel(err)) {
        return Promise.reject(err);
      }

      console.error(err);
      const miseEnAttente = intercepterUnauthorized(err, instance);
      if (miseEnAttente) {
        return miseEnAttente;
      }
      if (err.response && err.response.status && err.response.status === 403) {
        // Ne pas intercepter les erreurs pour certaines routes comme les tâches et notifications,
        // ni celles dont l'appelant gère le refus lui-même (sansPageErreur).
        // Impact minime sur l'utilisateur de toute manière.
        if (!err.config?.sansPageErreur && !ignorePaths.some((path) => err.request.responseURL.includes(path))) {
          store.commit("setErrorStatus", err.response.status);
        }
      }
      return Promise.reject(err);
    },
  );

  return instance;
};
